import { useCallback, useState } from "react";
import _ from "lodash";
import axios from "axios";

import { config } from "../constants/config";
import { EResultGroups } from "../types/ResultGroups";
import { ERequestState } from "../types/RequestState";
import { ESearchLocations } from "../types/SearchLocations";
import { endpoints } from "./endpoints";

const instance = axios.create({
	baseURL: config.API_DOMAIN,
});

const responsesFormatter = (results, isArabic) => {
	const groupsSettings = {
		[ESearchLocations["explore-resources"].type]: {
			type: ESearchLocations["explore-resources"].type,
			title: isArabic ? "مركز المعرفة" : "Parent Resources",
		},
		[ESearchLocations["page"].type]: {
			type: ESearchLocations["page"].type,
			title: isArabic ? "الروابط" : "Links",
		},
		[ESearchLocations["tribe_events"].type]: {
			type: ESearchLocations["tribe_events"].type,
			title: isArabic ? "الفعاليات" : "Events",
		},
		[ESearchLocations["post"].type]: {
			type: ESearchLocations["post"].type,
			title:  isArabic ?  "آخر الأخبار"  : "Announcements",
		},
	};

	const groupsObj = {};

	for (const { data } of results) {
		for (const item of data) {
			if (!(item.subtype in groupsObj)) {
				groupsObj[item.subtype] = {
					...groupsSettings[item.subtype],
					resultItems: [item],
				};
			} else groupsObj[item.subtype].resultItems.push(item);
		}
	}

	const groups = [];

	for (const group in groupsObj) groups.push(groupsObj[group]);

	return groups;
};

export const useApi = (searchField, types) => {
	const [groups, setGroups] = useState([]);
	const [request, setRequest] = useState(ERequestState.Init);
	const [siteLang, setSiteLang] = useState("en");

	

	const makeRequest = useCallback(() => {
		async function fetchData() {
			if (!searchField.trim().length) return setRequest(ERequestState.Init);

			const { url, lang = "en" } = window["local_data"];
			setSiteLang(lang);
			const URLs = endpoints.globalSearch({
				address: url,
				searchField,
				types,
				lang,
			});

			// console.log(URLs);

			let responses = null;

			try {
				//*
				setRequest(ERequestState.IsLoading);

				responses = await Promise.all(_.map(URLs, (url) => axios.get(url)));
				//*
			} catch (error) {
				//*
				console.log(
					"An error has occured while is fetching for global search: ",
					error
				);

				setRequest(ERequestState.EmptyResponse);

				return setGroups([]);
				//*
			}
			// console.log("responses", responses);

			const groups = responsesFormatter(responses, lang.toLowerCase().includes('ar'));

			if (_.size(groups)) {
				setRequest(ERequestState.WithResult);

				setGroups(groups);
			} else {
				setRequest(ERequestState.EmptyResponse);

				setGroups([]);
			}
		}

		fetchData();
	}, [searchField, types]);

	return {
		groups: groups || [],
		request,
		makeRequest,
		lang: siteLang,
	};
};
